module.exports = __webpack_public_path__ + "media/svg/logoBcertifie-06a3c234.svg";